export const CORE_CALENDAR_CREATE_CALENDAR_EVENTS =
  "core_calendar_create_calendar_events";
export const CORE_CALENDAR_DELETE_CALENDAR_EVENTS =
  "core_calendar_delete_calendar_events";
export const CORE_CALENDAR_GET_CALENDAR_EVENTS =
  "core_calendar_get_calendar_events";

export const QUERY_KEY_CALENDAR_EVENTS = "calendar-events";

export const DATE_TIME_FORMAT = {
    YYYY_MM_DD: "YYYY-MM-DD",
    HH_mm: "HH:mm"
}

export const DUMMY_DATE = "2020-10-10";
export const INVALID_DATE = "Invalid Date";
export const QUERY_KEY = {
  CALENDAR_EVENTS: "calendar-events",
};

export const CALENDAR_EVENT_DEFAULT_VALUE = {
  title: "",
  start: "",
  end: "",
  start_time: "",
  end_time: "",
  description: "",
};
